export default __webpack_public_path__ + "static/media/640_portfolio04-it-web.4c8f4303.png";